import { useQueryClient } from '@tanstack/react-query'
import { usePostProvidersUserIdLicenses, getGetProvidersUserIdQueryKey } from '@/api/generated/doctor/doctor'
import { formValuesToRequestBody } from '../license-form/transformLicense'
import type { LicenseFormValues } from '../license-form/LicenseFormSchema'

export function useCreateLicense(userId: string) {
  const queryClient = useQueryClient()
  const { mutateAsync: orvalMutateAsync, isPending } = usePostProvidersUserIdLicenses()

  async function mutateAsync(values: LicenseFormValues) {
    const data = formValuesToRequestBody(values)
    await orvalMutateAsync({ userId, data })

    const queryKey = getGetProvidersUserIdQueryKey(userId)
    queryClient.invalidateQueries({ queryKey })
  }

  return { mutateAsync, isPending }
}
